(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/toplists/receiver-toplists-last-picked.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/toplists/receiver-toplists-last-picked.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.receiver_toplists_last_picked = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-receiver-toplists-last-picked\"></div>";
},"useData":true});
Handlebars.partials['svs-grassroots_shared-receiver_toplists_last_picked'] = svs.grassroots_shared.templates.receiver_toplists_last_picked;
})(svs, Handlebars);


 })(window);